// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shop_box{padding:50px 20px 20px 30px;min-height:410px;text-align:center;-webkit-box-sizing:border-box;box-sizing:border-box}.shop_box button{margin-top:20px}.shop_box>div{margin-bottom:20px}.el-descriptions-item__container .el-descriptions-item__label:not(.is-bordered-label){-ms-flex-negative:0;flex-shrink:0}.el-tag,.el-tag--small{white-space:normal;height:auto}", ""]);
// Exports
module.exports = exports;
